import { render, staticRenderFns } from "./unicomDeal3.vue?vue&type=template&id=38dd5030&scoped=true"
import script from "./unicomDeal3.vue?vue&type=script&lang=js"
export * from "./unicomDeal3.vue?vue&type=script&lang=js"
import style0 from "./unicomDeal3.vue?vue&type=style&index=0&id=38dd5030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd5030",
  null
  
)

export default component.exports